import { z } from 'zod';
/**
 * Dashboard — a tela que abre depois do login.
 *
 * Uma chamada só: o gestor quer a foto da garagem em um segundo, não seis
 * requisições encadeadas. Tudo aqui é derivado dos estados do processo, nada
 * é digitado — é o princípio do PRD (seção 1) aplicado à tela principal.
 */
/** Janelas de histórico que o Dashboard oferece, em dias. */
export const DASHBOARD_PERIODS = [7, 30, 90, 180, 365];
export const DEFAULT_DASHBOARD_PERIOD = 30;
export const dashboardQuerySchema = z.object({
    /** Janela do histórico (MKBF do período, quebras, tempo parado, eventos). */
    days: z.coerce
        .number()
        .int()
        .refine((d) => DASHBOARD_PERIODS.includes(d), 'Período inválido')
        .default(DEFAULT_DASHBOARD_PERIOD),
    /** Meses da série mensal do MKBF; por padrão cobre o período com folga. */
    months: z.coerce.number().int().min(3).max(24).optional(),
});
//# sourceMappingURL=dashboard.schemas.js.map